import { useState } from 'react';
import { optimaChartData } from '../../../helpers/data';
import { useTestContext } from '../../../context/testContext';
import { PanelTitle, SessionActions, useAutoHideVideo } from '../../../ui';
import { ExamBody } from '../exams/common';
import { StartSizeList } from '../exams/StartSizeList';

// Near Vision step 2 "Please select a starting text size" (Figma session/16 right): n104 — n72 ...
// n6 — n4. Stores the chosen optimaChartData group as testData.startingTextSize (unchanged).
const ICNVision = ({ updateStep, eyeTested }) => {
  const [canProgress, setCanProgress] = useState(false);
  const { testData, updateTestData } = useTestContext();
  useAutoHideVideo();

  const handleSelection = (startingTextSize) => {
    updateTestData({ startingTextSize });
    setCanProgress(true);
  };

  return (
    <ExamBody style={{ gap: 16 }}>
      <PanelTitle small>Please select a starting text size</PanelTitle>
      <StartSizeList
        label='Starting text size'
        rows={optimaChartData.map((group) => ({ id: group.id, group, cells: [group.value] }))}
        selectedId={canProgress ? testData.startingTextSize?.id : null}
        onSelect={(row) => handleSelection(row.group)}
      />
      <SessionActions onBack={() => updateStep('eyeSetup')} primary={{ label: 'Next', onClick: () => updateStep(`${eyeTested}Test`), disabled: !canProgress }} />
    </ExamBody>
  );
};

export default ICNVision;
